import { BaseIcon, EthIcon, MyAlgoIcon, StellarIcon } from 'src/common/assets'
import { ChainName } from './name'

export const WALLET_ICON = {
  [ChainName.ETHEREUM]: EthIcon,
  [ChainName.ALGORAND]: MyAlgoIcon,
  [ChainName.STELLAR]: StellarIcon,
  [ChainName.BASE]: BaseIcon
}
